var _path, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWebLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33317 4.66699V4.66699C9.33317 3.56242 8.43774 2.66699 7.33317 2.66699H5.99984C4.75368 2.66699 4.13061 2.66699 3.6665 2.93494C3.36247 3.11048 3.10999 3.36295 2.93445 3.66699C2.6665 4.13109 2.6665 4.75417 2.6665 6.00032V7.33366C2.6665 8.43823 3.56193 9.33366 4.6665 9.33366V9.33366",
    stroke: "#456BD9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.6665,
    y: 6.66699,
    width: 6.66667,
    height: 6.66667,
    rx: 2,
    stroke: "#456BD9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLink);
export default __webpack_public_path__ + "static/media/web_link.c611aac7ea50504806fac5c3dfe35ba0.svg";
export { ForwardRef as ReactComponent };